import React, { useState } from 'react';
import SpinnerCard from './SpinnerCard';
import BookingCategoryGroupSelection from './BookingCategoryGroupSelection';
import EditableHeader from './EditableHeader';
import { Alert, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStethoscope } from '@fortawesome/free-solid-svg-icons'

function BookingCategorySelection(props) {

    let [selectedTypeName, setSelectedTypeName] = useState('');

    function onSelect(booking) {
        setSelectedTypeName(booking.Name);
        props.onSelect(booking);
    }

    function onEdit() {
        props.onEdit();
    }

    function isShown() {
        return props.shownControl === 'category';
    }

    function isSaved() {
        return selectedTypeName !== ''
    }

    function isEditable() {
        return !props.bookingSaved;
    }

    function isLoaded() {
        return props.customerData !== undefined;
    }

    function getCategories() {
        if (!isShown()) {
            if (!isSaved()) {
                return (
                    <Alert variant="section-header">
                        Välj bokningskategori
                    </Alert>
                );
            } else {
                if (isEditable()) {
                    return (
                        <EditableHeader icon={faStethoscope} onEdit={onEdit} selectedValue={selectedTypeName} header="Vald bokningskategori: " />
                    );
                } else {
                    return (
                        <Alert variant="saved-header">
                            <FontAwesomeIcon icon={faStethoscope} style={{ marginRight: 10 }} />
                            Vald bokningskategori: <b>{selectedTypeName}</b>
                        </Alert>
                    );
                }
            }
        }
        if (!isLoaded()) {
            return (
                <Row className="justify-content-center align-items-center row-eq-height">
                    <SpinnerCard />
                </Row>
            );
        } else {
            return (
                <Container xs={12}>
                    <Alert variant="section-header">
                        <FontAwesomeIcon icon={faStethoscope} style={{ marginRight: 10 }} />
                        Välj bokningskategori
                    </Alert>
                    <BookingCategoryGroupSelection customerData={props.customerData} onSelect={onSelect}>
                    </BookingCategoryGroupSelection>
                </Container>
            );
        }
    }

    return getCategories();
}

export default BookingCategorySelection;